/**
 * Constants migrated from legacy setup.js
 */

export const getConstants = () => {
  const config = useRuntimeConfig().public;

  return {
    baseURL: config.apiUrl,
    clientURL: config.clientUrl,
    appURL: config.appUrl,
    APP_ENV: config.appEnv,
    PUSHER_ID: config.pusherId,
    APP_VERSION: config.appVersion,
    PUSHER_BEAMS_ID: config.pusherBeamsId,
    PUBLIC_PATHS: [
      'login',
      'signup',
      'signup-offer',
      'reset-password',
      'restore-password',
      'activation',
      'thank-you',
      'checkout',
      'products',
    ],
  };
};

export const JOURNALING_SURVEY_ALIAS = 'journaling';
export const VIDEOCALL_SURVEY_ALIAS = 'videocall';
export const INFO_PATHS_SURVEY_ALIAS = 'info_paths';
export const MOOD_QUESTION_ALIAS = 'question_1';
export const THOUGHT_QUESTION_ALIAS = 'question_3';

export const IGNORED_ERROR_CODES = [
  1001,
  1002,
  1003,
  1005,
  2001,
  2002,
  2003,
  2005,
  3001,
  3002,
  3003,
  3005,
  4001,
  4002,
  4003,
  4005,
];

export const ROLES = {
  admin: 1,
  trader: 2,
  doctor: 3,
  user: 4,
  staff: 5,
  guest: 6,
  tech: 7,
  guest_family: 8,
};

export const FAKE_ACTIVITIES = [
  {
    day: 0,
    from: '06:00',
    to: '06:30',
    model_type: 'App\\Models\\GroupActivitySchedule',
    name: 'Gruppo Routine',
    id: 20,
    in_progress: true,
    ended: false,
    fake: true,
    desc: 'Un risveglio attivo per iniziare la giornata con consapevolezza.',
  },
  {
    day: 0,
    from: '18:00',
    to: '19:00',
    model_type: 'App\\Models\\GroupActivitySchedule',
    name: 'Gruppo di Supporto',
    id: 18,
    in_progress: true,
    ended: false,
    fake: true,
    desc: 'Un momento per ascoltare e farsi ascoltare nel cammino del cambiamento.',
  },
  {
    day: 1,
    from: '08:00',
    to: '08:30',
    model_type: 'App\\Models\\GroupActivitySchedule',
    name: 'Gruppo Routine',
    id: 20,
    in_progress: true,
    ended: false,
    fake: true,
    desc: 'Un risveglio attivo per iniziare la giornata con consapevolezza.',
  },
  {
    day: 1,
    from: '20:00',
    to: '21:00',
    model_type: 'App\\Models\\GroupActivitySchedule',
    name: 'Gruppo Coaching',
    id: 85,
    in_progress: true,
    ended: false,
    fake: true,
    desc: 'Confrontati con il coach e il gruppo per rafforzare motivazione e obiettivi.',
  },
  {
    day: 2,
    from: '06:00',
    to: '06:30',
    model_type: 'App\\Models\\GroupActivitySchedule',
    name: 'Gruppo Routine',
    id: 20,
    in_progress: true,
    ended: false,
    fake: true,
    desc: 'Un risveglio attivo per iniziare la giornata con consapevolezza.',
  },
  {
    day: 2,
    from: '14:00',
    to: '15:00',
    model_type: 'App\\Models\\GroupActivitySchedule',
    name: 'Gruppo CBT',
    id: 119,
    in_progress: true,
    ended: false,
    fake: true,
    desc: 'Tecniche cognitive e pratiche per gestire i tuoi pensieri.',
  },
  {
    day: 3,
    from: '18:00',
    to: '19:00',
    model_type: 'App\\Models\\SingleActivitySchedule',
    name: 'Colloquio Motivazionale',
    id: 152,
    in_progress: true,
    ended: false,
    fake: true,
    desc: 'Un confronto individuale per ritrovare forza e direzione.',
  },
  {
    day: 4,
    from: '08:00',
    to: '08:30',
    model_type: 'App\\Models\\GroupActivitySchedule',
    name: 'Gruppo Routine',
    id: 20,
    in_progress: true,
    ended: false,
    fake: true,
    desc: 'Un risveglio attivo per iniziare la giornata con consapevolezza.',
  },
  {
    day: 4,
    from: '18:00',
    to: '19:00',
    model_type: 'App\\Models\\GroupActivitySchedule',
    name: 'Parola e Condivisione',
    id: 110,
    in_progress: true,
    ended: false,
    fake: true,
    desc: 'Uno spazio sicuro dove raccontarsi, riflettere e crescere insieme.',
  },
];

export const USER_TYPES = {
  famigliare: 51,
};

export const PERMISSIONS = [
  {
    id: 2,
    name: 'dashboard',
  },
  {
    id: 5,
    name: 'pti',
  },
  {
    id: 7,
    name: 'history_sheet',
  },
  {
    id: 145,
    name: 'reports',
  },
];

export const SYSTEM_LOGS_LEVELS = [
  { id: 'INFO', name: 'INFO', class: 'info' },
  { id: 'DEBUG', name: 'DEBUG', class: 'default' },
  { id: 'WARNING', name: 'WARNING', class: 'warning' },
  { id: 'ERROR', name: 'ERROR', class: 'danger' },
];

export const SURVEY_ID = 2;
export const SURVEY_CLIENT_ID = 2;
export const SURVEY_GROUP_ID = 3;
export const SURVEY_SINGLE_ANSWER = 115;
export const SURVEY_MULTIPLE_ANSWER = 116;
export const EQUIPE_GUEST_ID = 1987;
export const SUPPORT_USER_ID = 3028;
export const STANDUP_COACH_ID = 3132;

export const languages = ['it'];
export const DEFAULT_LOCALE = 'it';
